/**
 * Mapeo de estado actual → color + label · simplificado al subconjunto
 * de estados a los que puede llegar una solicitud DESPUÉS de pasar por
 * el flujo de autorización (todos los previos quedan filtrados por la
 * query de historial · no aparecen aquí).
 */
export function badgeEstadoActual(
  estado: string,
  nivel?: { nivelAutorizado?: number; cantidadNiveles?: number }
): {
  color: string;
  label: string;
} {
  switch (estado) {
    case "EnAutorizacionNivel1":
      return { color: "info", label: "En autorización nivel 1" };
    case "EnAutorizacionNivelN": {
      // El nivel al que avanzó la solicitud tras esta firma. El último nivel
      // del flujo es la Mesa de Control (decisión de dominio).
      const proximoNivel = (nivel?.nivelAutorizado ?? 0) + 1;
      const esUltimo =
        nivel?.cantidadNiveles != null && proximoNivel >= nivel.cantidadNiveles;
      if (esUltimo) {
        return { color: "info", label: "En autorización Mesa de Control" };
      }
      return {
        color: "info",
        label:
          nivel?.nivelAutorizado != null
            ? `En autorización nivel ${proximoNivel}`
            : "En autorización nivel siguiente",
      };
    }
    case "ListoParaAutorizacion":
      return { color: "azulCielo", label: "Lista para autorización" };
    case "EnRevisionDocumental":
      return { color: "info", label: "En revisión documental" };
    case "RechazadaParaCorreccion":
      return { color: "advertencia", label: "Rechazada · corrigiendo" };
    case "Autorizada":
      return { color: "exito", label: "Autorizada" };
    // Contabilización · azul cielo de la paleta (deepskyblue/dodgerblue).
    case "EnColaContabilizacion":
      return { color: "azulCielo", label: "En cola SAP" };
    case "PolizaGenerada":
      return { color: "azulCielo", label: "Póliza generada" };
    case "EnviadaAContabilizacion":
      return { color: "azulCielo", label: "Enviada a SAP" };
    case "DadaDeBajaPorAutorizador":
      return { color: "peligro", label: "Baja por Mesa de Control" };
    default:
      return { color: "slate", label: estado };
  }
}
